import { RootState } from "../state";
import { RawTriggerData } from "@/components/TriggerSetup/logic/types/types";
import { ITriggersState } from "@/store/triggers/state";

import { cloneDeep } from "lodash";

export default {
  UPDATE_TRIGGERS(state: RootState, val: ITriggersState['triggers']) {
    state.triggersState.triggers = val;
  },
  setNewTrigger(state: RootState, trigger: RawTriggerData) {
    state.triggersState.newTrigger = cloneDeep(trigger);
  },
  resetNewTrigger(state: RootState) {
    state.triggersState.newTrigger = null;
  },
  resetFrontendTriggers(state: RootState) {
    state.triggersState.triggers = null
  },
  SET_UPDATED_TRIGGER_ID(state: RootState, triggerId: string | null) {
    if (triggerId) {
      state.triggersState.updatedTriggerId = triggerId;

      setTimeout(() => {
        state.triggersState.updatedTriggerId = null;
      }, 30000)
    } else {
      state.triggersState.updatedTriggerId = triggerId;
    }
  },
};
